import groq from 'groq';

import { SOCIAL_MEDIA_STORY } from '../common/socialMediaStory';

export const SOCIAL_MEDIA_CAROUSEL = groq`
  items[]-> {
    ${SOCIAL_MEDIA_STORY}
  },
  eyebrow,
  cta {
    title,
    href
  }
`;

export const SOCIAL_MEDIA_CAROUSEL_BLOCK = groq`
  _type == 'socialMediaCarousel' => @-> {
    ${SOCIAL_MEDIA_CAROUSEL}
  }
`;
